<template>
  <div class="material-manage">
    <!-- 筛选查询 -->
    <el-card class="filter-card">
      <app-filter
        :filter-list="table_filter"
        @search="searchTable"
      />
    </el-card>

    <!-- 素材报表折线图 -->
    <div v-if="is_exist_search">
      <el-card
        v-for="(line_item, key) in line_config"
        :key="key"
        v-loading="is_loading"
        class="box-card"
      >
        <div>
          <label>{{ line_item.label }}：</label>
          <el-select
            v-model="line_item.value"
            size="mini"
            :placeholder="'请选择' + line_item.label"
            @change="updateLine(key, line_item.value)"
          >
            <el-option
              v-for="(item, index) in line_item.options"
              :key="index"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </div>
        <base-line
          ref="lineDom"
          v-loading="line_item.is_loading"
          style="width: 100%; height: 500px"
          v-bind="line_item.config"
        />
      </el-card>
    </div>

    <!-- 素材报表列表 -->
    <el-card v-loading="is_loading" class="show-table-card">
      <div>
        <label>{{ show_table_data.label }}：</label>
        <el-select
          v-model="show_table_data.value"
          size="mini"
          multiple
          filterable
          class="w-full mt-15"
          :placeholder="'请选择' + show_table_data.label"
          @change="onFieldsChange"
        >
          <el-option
            v-for="(item, index) in show_table_data.options"
            :key="index"
            :disabled="item.disabled"
            :label="item.name"
            :value="item"
          />
        </el-select>
      </div>
      <div class="mt-15">
        <el-checkbox v-model="table_params.is_merge_by_local_material_id" true-label="1" false-label="0" @change="onMergeLocalMaterialId">按素材库ID合并所选时间内的数据</el-checkbox>
      </div>
      <app-table
        ref="report_table"
        class="mt-15"
        :table-key="[
          ...table_key,
          ...show_table_data.value
        ]"
        :tablep="table_params"
        :table-on="table_on"
        :get-data="getMaterialList"
        :is-request="false"
      />
    </el-card>
  </div>
</template>

<script>
import {
  getMaterialVideoReportApi,
  getMaterialImageReportApi,
  getMaterialTitleReportApi,
  getMaterialTableReportApi,
} from '@/api/report/jrtt/material';
import { getMediasListApi } from '@/api/medias';

import { getProjectSelectorApi } from '@/api/project/jrtt';
import { getPromotionSelectorApi } from '@/api/promotion/jrtt';
import { getLineChart } from './model/line-chart-config';
import { BaseLine } from '@/components/re-echart';
import { isEmpty } from '@/utils/is';
import { clone } from '@/utils';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
    'material-preview': () => import('@/views/auxiliary/material-library/components/material-preview'),
    BaseLine,
  },
  data() {
    return {
      table_filter: require('./model/table-filter')(this),
      /** 表格请求参数 */
      table_params: {
        page: 1,
        limit: 10,
        // 是否按本地素材ID合并数据 ‘0’：否；‘1‘：是
        is_merge_by_local_material_id: '0',
      },

      // 是否加载
      is_loading: false,

      // 项目筛选框
      project_ids: {
        options: [],
        value: [],
      },

      /** 表格数据 */
      table_list_data: {
        list: [{
          id: 1,
        }],
      },

      /**
       * 素材配置
       */
      material_config: {
        is_show: false,
        title: '创建素材',
        data: {},
      },

      /**
       * 线形图配置
       */
      line_config: {
        video: {
          label: '视频类型',
          is_loading: false,
          options: require('./model/field-config')(this).filter(item => !item.disabled),
          value: '',
          config: {
            lineData: [],
            xAxis: {
              data: [],
            },
            yAxis: {
              type: 'value',
              data: [],
            },
          },
        },
        image: {
          label: '图片类型',
          is_loading: false,
          options: require('./model/field-config')(this).filter(item => !item.disabled),
          value: '',
          config: {
            lineData: [],
            xAxis: {
              data: [],
            },
            yAxis: {
              type: 'value',
              data: [],
            },
          },
        },
        title: {
          label: '标题类型',
          is_loading: false,
          options: require('./model/field-config')(this).filter(item => !item.disabled),
          value: '',
          config: {
            lineData: [],
            xAxis: {
              data: [],
            },
            yAxis: {
              type: 'value',
              data: [],
            },
          },
        },
      },
      // 显示表格数据
      show_table_data: {
        label: '显示表格数据',
        options: require('./model/field-config')(this),
        value: require('./model/field-config')(this),
      },
      table_key: require('./model/table-key')(this),
      // 表格事件
      table_on: {
        'sort-change': ({ prop, order }) => {
          delete this.table_params.sort_order;
          delete this.table_params.sort_prop;
          const mapOrder = {
            descending: 'DESC',
            ascending: 'ASC',
          };
          mapOrder[order] && Object.assign(this.table_params, {
            sort_prop: prop,
            sort_order: mapOrder[order],
          });
          this.$refs.report_table.seekTable();
        },
      },
    };
  },
  computed: {
    /** 是否存在查询参数 */
    is_exist_search(){
      return !isEmpty(this.getPostData());
    },
  },
  created(){
    this.getMediasList();

    const { advertiser_id, project_id, promotion_id } = this.$route.query;
    if (advertiser_id) {
      this.table_filter.advertiser_ids.value = [Number(advertiser_id)];
      this.getProjectSelector();
      this.getAdSelector();
    }

    if (project_id) {
      this.table_filter.project_ids.value = [project_id];
    }

    if (promotion_id) {
      this.table_filter.promotion_ids.value = [promotion_id];
    }
  },
  methods: {
    /**
     * 查询表格
     * @param {*} params_value
     */
    searchTable(params_value) {
      const { date } = params_value;
      if (date?.length) {
        params_value['start_date'] = date[0];
        params_value['end_date'] = date[1];
        delete params_value.date;
      }

      this.table_params = {
        ...this.table_params,
        ...params_value,
        'fields': this.show_table_data.value.map(item => item.value),
      };

      // 视频目标图表选中指标
      if (this.line_config.video.value) {
        this.updateLine('video');
      }

      // 图片图表选中指标
      if (this.line_config.image.value) {
        this.updateLine('image');
      }

      // 标题图表选中指标
      if (this.line_config.title.value) {
        this.updateLine('title');
      }

      this.$nextTick(() => {
        this.$refs.report_table.seekTable();
      });
    },

    /**
     * 修改素材
     * @param { Object } row 行数据
     */
    editMaterial(row) {
      this.material_config.is_show = true;
      this.material_config.data = row;
    },

    /**
     * 素材表单取消
     */
    materialFormCancel() {
      if (this.material_config.data) {
        this.material_config.data = null;
      }

      this.material_config.is_show = false;
    },

    /**
     * 素材表单确定
     */
    materialFormConfirm() {
      this.materialFormCancel();
    },

    /** 获取广告账号列表 */
    getMediasList() {
      return getMediasListApi({
        type: 'jrtt',
        is_list: true,
      }).then((res) => {
        this.table_filter.advertiser_ids.options = res.list.map((accoun_item) => {
          return {
            label: `${accoun_item.advertiser_id}(${accoun_item.advertiser_name})${accoun_item.note ? ' - ' + accoun_item.note : ''}`,
            value: accoun_item.advertiser_id,
          };
        });
      });
    },

    /** 获取项目选择器列表 */
    getProjectSelector() {
      if (this.table_filter.advertiser_ids?.value) {
        this.table_filter.project_ids.value = [];
        return getProjectSelectorApi({
          advertiser_ids: this.table_filter.advertiser_ids.value,
        }).then((res) => {
          this.table_filter.project_ids.options = res.list.map((item) => {
            return {
              label: item.name,
              value: item.type_id,
            };
          });
        });
      }
    },

    /** 获取广告选择器列表 */
    getAdSelector() {
      if (this.table_filter.advertiser_ids?.value) {
        return getPromotionSelectorApi({
          advertiser_ids: this.table_filter.advertiser_ids.value,
        }).then((res) => {
          this.table_filter.promotion_ids.options = res.list.map((item) => {
            return {
              label: item.name,
              value: item.type_id,
            };
          });
        });
      }
    },

    /** 获取素材列表 */
    getMaterialList(params) {
      return new Promise((resolve, reject) => {
        /** 不存在查询参数时直接reject并终止代码执行 */
        if (!this.is_exist_search) {
          reject();
          return;
        }
        getMaterialTableReportApi(params).then((res) => {
          resolve(res);
          this.setDateKeyProps();
        }).catch(reject);
      });
    },

    /**
     * 更新折线图
     * @param {string} key 键值
     */
    updateLine(key) {
      switch (key) {
        case 'video':
          this.getMaterialVideoReport();
          break;
        case 'image':
          this.getMaterialImageReport();
          break;
        case 'title':
          this.getMaterialTitleReport();
          break;
      }
    },

    /**
     * 获取视频素材报表
     */
    getMaterialVideoReport() {
      let options_data = [];

      this.line_config.video.is_loading = true;
      getMaterialVideoReportApi({
        ...this.getPostData(),
        image_mode: this.$store.getters.jrttEnum.api_2_creative_video_mode.map(item => item.value),
        field: this.line_config.video.value,
      }).then((res) => {
        options_data = res.list;
        this.line_config.video.config.lineData = res.list.map(item => item[1]);
        const video_line_config = getLineChart(options_data, this.$store.getters.jrttEnum.api_2_creative_video_mode);
        this.$refs.lineDom[0].init(video_line_config);
      }).finally(() => {
        this.line_config.video.is_loading = false;
      });
    },

    /**
     * 获取图片素材报表
     */
    getMaterialImageReport() {
      let options_data = [];
      this.line_config.image.is_loading = true;
      getMaterialImageReportApi({
        ...this.getPostData(),
        image_mode: this.$store.getters.jrttEnum.api_2_creative_image_mode.map(item => item.value),
        field: this.line_config.image.value,
      }).then((res) => {
        options_data = res.list;
        const image_line_config = getLineChart(options_data, this.$store.getters.jrttEnum.api_2_creative_image_mode);
        this.line_config.image.config.lineData = [''];
        this.$refs.lineDom[1].init(image_line_config);
      }).finally(() => {
        this.line_config.image.is_loading = false;
      });
    },

    /**
     * 获取标题素材报表
     */
    getMaterialTitleReport() {
      let options_data = [];
      this.line_config.title.is_loading = true;
      getMaterialTitleReportApi({
        ...this.getPostData(),
        image_mode: this.$store.getters.jrttEnum.api_2_creative_title_mode.map(item => item.value),
        field: this.line_config.title.value,
      }).then((res) => {
        options_data = res.list;
        const title_line_config = getLineChart(options_data, this.$store.getters.jrttEnum.api_2_creative_title_mode);
        this.line_config.title.config.lineData = [''];
        this.$refs.lineDom[2].init(title_line_config);
      }).finally(() => {
        this.line_config.title.is_loading = false;
      });
    },

    /** 按素材库ID合并所选时间内的数据 */
    onMergeLocalMaterialId() {
      if (!this.is_exist_search) {
        return;
      }
      this.$nextTick(() => {
        this.$refs.report_table.seekTable();
      });
    },

    /** 监听指标改变 */
    onFieldsChange() {
      Object.assign(this.table_params, { 'fields': this.show_table_data.value.map(item => item.value) });
    },

    /** 设置时间表格列属性 */
    setDateKeyProps() {
      Object.assign(this.table_key[0].props, { width: this.table_params.is_merge_by_local_material_id === '1' ? 280 : 100 });
    },

    /** 获取图表查询所需参数 */
    getPostData() {
      const post_data = clone(this.table_params);
      delete post_data.page;
      delete post_data.limit;
      delete post_data.fields;
      delete post_data.is_merge_by_local_material_id;
      return post_data;
    },
  },
};
</script>

<style lang="scss" scoped>
.material-manage {
  .func-box {
    .el-button {
      margin-left: 10px;
    }
  }
  .w-full {
    width: 100%;
  }
  .mt-15 {
    margin-top: 15px;
  }
}
/deep/ .el-card {
    margin-bottom: 20px;
}
</style>
